import { Band, displayFont } from "./band-helpers";
import { StorefrontIcon } from "@/components/storefront-icon";

export function ChefsLetterBand() {
  return (
    <Band
      className="relative overflow-hidden bg-[#132e16] py-16 sm:py-20 lg:py-28"
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
        }}
      />

      <div className="relative mx-auto max-w-4xl text-center">
        <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-white/12 bg-white/8 text-white backdrop-blur-sm">
          <StorefrontIcon context="feature" label="chef" className="h-7 w-7" />
        </span>

        <figure className="mt-8" role="figure" aria-label="Chef's letter">
          <blockquote>
            <p
              className={`${displayFont.className} text-[clamp(1.85rem,3.6vw,3.2rem)] font-semibold leading-[1.06] tracking-tight text-white`}
            >
              &ldquo;I cook the way my mother taught me and her mother taught her.
              There are no shortcuts. The rice is smoked properly, the stew
              simmers until it is right, and every plate that leaves this kitchen
              is one I would serve my own family.&rdquo;
            </p>
          </blockquote>

          <figcaption className="mt-8">
            <cite className="not-italic">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#9cd4a0]">
                Chef Adebayo
              </p>
              <p className="mt-1 text-sm text-white/50">
                Head Chef, Aso Rock Kitchen
              </p>
            </cite>
          </figcaption>
        </figure>
      </div>
    </Band>
  );
}
